// src/App.js

import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

// Importe seus componentes que funcionam como páginas
// (Os nomes e caminhos abaixo são exemplos, ajuste para o seu projeto se forem diferentes)
import Header from './components/Header';
import FormPage from './components/FormPage'; 
import SuccessPage from './components/steps/SuccessPage'; // A página de sucesso que criamos

function App() {
  return (
    <Router>
      {/* O Header fica fora do <Routes> para aparecer em todas as páginas */}
      <Header />
      
      {/* O <Routes> decide qual página mostrar com base na URL */}
      <Routes>
        {/* Rota para a página que contém o formulário */}
        <Route path="/forms" element={<FormPage />} />

        {/* Rota para a nova página de sucesso */}
        <Route path="/obrigado" element={<SuccessPage />} />
        
        {/* Rota principal: faz da página de formulário a página padrão */}
        <Route path="/" element={<FormPage />} />
      </Routes>
    </Router>
  );
}

export default App;